import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { ApiResponse } from "@/utils/ApiResponse";
import { MarcaProductoInterface } from "../../interfaces/marcaProductosInterfaces/MarcaProducto.interface";
import { useToast } from "vue-toastification";
import { DeleteMarcaProductoAction } from "../../actions/marcaActions";

const toast = useToast();

export function useMarcaProductoDelete(onClose?: () => void) {
  const queryClient = useQueryClient();

  // Mutation para eliminar la marca de producto
  const mutation = useMutation({
    mutationFn: (marcaId: string) => DeleteMarcaProductoAction(marcaId),
    onSuccess: async (response: ApiResponse<MarcaProductoInterface>) => {
      await queryClient.invalidateQueries({ queryKey: ["MarcaProductosList"] });
      toast.success("La marca de producto fue eliminada correctamente");
      if (onClose) onClose();
    },

    onError: (error: unknown) => {
      toast.error("Error al eliminar la marca de producto");
      if (onClose) onClose();
    },
  });

  return {
    ...mutation, // => { mutate, mutateAsync, isPending, isError, error, isSuccess, data }
  };
}
